var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showSpinner)?_c('Spinner'):_vm._e(),_vm._t("default",null,{"slottedLabels":_vm.slottedLabels})],2)}
var staticRenderFns = []

export { render, staticRenderFns }